type LogLevel = 'error' | 'warn' | 'info' | 'verbose' | 'debug' | 'silly';

function log(level: LogLevel, message: string) {
  window.logAPI.sendLog(level, message);
}

// Catch all uncaught errors in renderer and send to main process via preload API
window.onerror = function (message, source, lineno, colno, error) {
  const errorMsg = error?.stack || `${message} at ${source}:${lineno}:${colno}`;
  window.logAPI.sendLog('error', `[Uncaught Renderer Error] ${errorMsg}`);
};

export const rendererLogger = {
  error: (msg: string) => log('error', msg),
  warn: (msg: string) => log('warn', msg),
  info: (msg: string) => log('info', msg),
  verbose: (msg: string) => log('verbose', msg),
  debug: (msg: string) => log('debug', msg),
  silly: (msg: string) => log('silly', msg),
};
